import React, {useState, useEffect} from "react";
import styles from "../Configuracao/styles.module.css";
import http from "../../../services/http";
import {alerta} from "../../../components/Alert";

const somenteDigitos2 = (v) => v.replace(/\D/g, '').slice(0, 2);

export function Comissao() {
    const [comissaoMilharMoto, setComissaoMilharMoto] = useState('');
    const [comissaoSeninha, setComissaoSeninha] = useState('');
    const [comissaoSenaBrasil, setComissaoSenaBrasil] = useState('');
    const [comissaoBolao, setComissaoBolao] = useState('');
    const [comissaoBolaoDezena, setComissaoBolaoDezena] = useState('');
    const [comissaoDoisPraQuinhentos, setComissaoDoisPraQuinhentos] = useState('');
    const [comissaoRifa, setComissaoRifa] = useState('');
    const [comissaoRaspadinha, setComissaoRaspadinha] = useState('');
    const [comissaoRaspadinhaGerente, setComissaoRaspadinhaGerente] = useState('');

    useEffect(() => {
        const buscarOpcoesBanca = async () => {
            try {
                const response = await http.get('/bancas/opcoes');

                const {opcoes} = response.data.data;

                const {
                    comissao_milhar_moto,
                    comissao_seninha,
                    comissao_sena_brasil,
                    comissao_bolao_dezena,
                    comissao_bolao,
                    comissao_dois_pra_quinhentos,
                    comissao_rifas,
                    comissao_raspadinha,
                    comissao_raspadinha_gerente,
                } = opcoes;

                setComissaoMilharMoto(String(comissao_milhar_moto ?? ''));
                setComissaoSeninha(String(comissao_seninha ?? ''));
                setComissaoSenaBrasil(String(comissao_sena_brasil ?? ''));
                setComissaoBolaoDezena(String(comissao_bolao_dezena ?? ''));
                setComissaoBolao(String(comissao_bolao ?? ''));
                setComissaoDoisPraQuinhentos(String(comissao_dois_pra_quinhentos ?? ''));
                setComissaoRifa(String(comissao_rifas ?? ''));
                setComissaoRaspadinha(String(comissao_raspadinha ?? ''));
                setComissaoRaspadinhaGerente(String(comissao_raspadinha_gerente ?? ''));
            } catch (e) {
                alerta(e.response.data)
            }
        };
        buscarOpcoesBanca();
    }, []);

    const atualizarComissoes = async () => {
        try {

            const response = await http.post('/bancas/opcoes', {
                comissao_milhar_moto: comissaoMilharMoto,
                comissao_seninha: comissaoSeninha,
                comissao_sena_brasil: comissaoSenaBrasil,
                comissao_bolao_dezena: comissaoBolaoDezena,
                comissao_bolao: comissaoBolao,
                comissao_dois_pra_quinhentos: comissaoDoisPraQuinhentos,
                comissao_rifas: comissaoRifa,
                comissao_raspadinha: comissaoRaspadinha,
                comissao_raspadinha_gerente: comissaoRaspadinhaGerente,
            });

            alerta(response.data)

        } catch (e) {
            alerta(e.response.data);
        }
    };

    const inputComissao = (setter) => (e) => setter(somenteDigitos2(e.target.value));

    return (
        <>
            <div className="titulo-principal">Comissões</div>
            <div className={styles.conteudoPrincipal}>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Comissão seninha:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            style={{width: 200}}
                            onChange={inputComissao(setComissaoSeninha)}
                            value={comissaoSeninha}
                            maxLength={2}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Comissão sena Brasil:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            style={{width: 200}}
                            onChange={inputComissao(setComissaoSenaBrasil)}
                            value={comissaoSenaBrasil}
                            maxLength={2}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Comissão bolão:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            style={{width: 200}}
                            onChange={inputComissao(setComissaoBolao)}
                            value={comissaoBolao}
                            maxLength={2}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Comissão bolão de dezenas:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            style={{width: 200}}
                            onChange={inputComissao(setComissaoBolaoDezena)}
                            value={comissaoBolaoDezena}
                            maxLength={2}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Comissão 2 Pra 500:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            style={{width: 200}}
                            onChange={inputComissao(setComissaoDoisPraQuinhentos)}
                            value={comissaoDoisPraQuinhentos}
                            maxLength={2}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Comissão rifa:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            style={{width: 200}}
                            onChange={inputComissao(setComissaoRifa)}
                            value={comissaoRifa}
                            maxLength={2}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Comissão raspadinha operador:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            style={{width: 200}}
                            onChange={inputComissao(setComissaoRaspadinha)}
                            value={comissaoRaspadinha}
                            maxLength={2}
                        />
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.label}>
                        <label>Comissão raspadinha gerente:</label>
                    </div>
                    <div className={styles.input}>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='form-control'
                            style={{width: 200}}
                            onChange={inputComissao(setComissaoRaspadinhaGerente)}
                            value={comissaoRaspadinhaGerente}
                            maxLength={2}
                        />
                    </div>
                </div>

                <div className={styles.buttonStyle}>
                    <button
                        className='btn btn-success'
                        style={{width: 200}}
                        onClick={atualizarComissoes}
                    >
                        Salvar
                    </button>
                </div>

            </div>
        </>
    );
}
